import { NumberSelectorProps } from "../number-selector/number-selector";
import { SelectInputProps } from "../select-input/select-input.types";
import { SliderMultipleValueProps } from "../slider/slider-multiple-value.types";
import { TextInputProps } from "../text-input/text-input.types";
import {
  CheckboxFilterInputProps,
  CustomMultiFilterInput,
  CustomSingleFilterInput,
  DateRangeFilterProps,
  FilterInputType,
  FilterModuleType,
  RadioFilterInputProps,
  ToggleFilterProps,
} from "./filter.types";

export const isCheckboxFilter = (
  type: FilterModuleType,
  input: FilterInputType
): input is CheckboxFilterInputProps => type === FilterModuleType.CHECKBOX;

export const isRadioFilter = (
  type: FilterModuleType,
  input: FilterInputType
): input is RadioFilterInputProps => type === FilterModuleType.RADIO;

export const isNumberSelectFilter = (
  type: FilterModuleType,
  input: FilterInputType
): input is NumberSelectorProps => type === FilterModuleType.NUMBER_SELECTOR;

export const isTextFilter = (
  type: FilterModuleType,
  input: FilterInputType
): input is TextInputProps => type === FilterModuleType.TEXT;

export const isSliderMultiValFilter = (
  type: FilterModuleType,
  input: FilterInputType
): input is SliderMultipleValueProps =>
  type === FilterModuleType.SLIDER_MULTI_VAL;

export const isToggleFilter = (
  type: FilterModuleType,
  input: FilterInputType
): input is ToggleFilterProps => type === FilterModuleType.TOGGLE;

export const isDateRangeFilter = (
  type: FilterModuleType,
  input: FilterInputType
): input is DateRangeFilterProps => type === FilterModuleType.DATE_RANGE;

export const isSelectFilter = (
  type: FilterModuleType,
  input: FilterInputType
): input is SelectInputProps => type === FilterModuleType.SELECT;

export const isCustomSingleFilter = (
  type: FilterModuleType,
  input: FilterInputType
): input is CustomSingleFilterInput => {
  return "children" in input && type === FilterModuleType.CUSTOM_SINGLE;
};

export const isCustomMultipleFilter = (
  type: FilterModuleType,
  input: FilterInputType
): input is CustomMultiFilterInput => {
  return (
    "renderInputItem" in input && type === FilterModuleType.CUSTOM_MULTIPLE
  );
};
